<template>
  <div class="employee-add-account">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="goEmployeeManage">员工账号/</span>新增账号
      </template>
      <template v-slot:content>
        <div class="employee-add-account-main">
          <div class="form-container">
            <div class="tit" ref="steps">基础信息</div>
            <div class="form">
              <el-form
                :model="ruleForm"
                :rules="rules"
                ref="ruleForm"
                label-position="right"
                label-width="90px"
              >
                <el-form-item label="登录账号：" prop="username">
                  <el-input v-model="ruleForm.username" class="gray" placeholder="请输入账号"></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="pass" :hide-required-asterisk="false">
                  <el-input
                    type="password"
                    v-model="ruleForm.pass"
                    class="gray"
                    placeholder="请输入密码"
                  ></el-input>
                </el-form-item>
                <el-form-item label="确认密码：" prop="checkPass">
                  <el-input
                    type="password"
                    v-model="ruleForm.checkPass"
                    class="gray"
                    placeholder="请确认密码"
                  ></el-input>
                </el-form-item>
                <div class="flex">
                  <el-form-item label="姓名：" prop="name">
                    <el-input v-model="ruleForm.name" class="gray" placeholder="请输入姓名"></el-input>
                  </el-form-item>
                  <el-form-item label="手机：" prop="phone" label-width="80px">
                    <el-input v-model="ruleForm.phone" class="gray" placeholder="请输入手机号"></el-input>
                  </el-form-item>
                </div>
                <div class="flex">
                  <el-form-item label="职位：" prop="position">
                    <el-input v-model="ruleForm.position" class="gray" placeholder="请输入职位"></el-input>
                  </el-form-item>
                  <el-form-item label="部门：" prop="department" label-width="80px">
                    <el-select
                      clearable
                      v-model="ruleForm.department"
                      placeholder="请选择部门"
                      class="gray"
                    >
                      <el-option
                        v-for="item in department"
                        :key="item.id"
                        :label="item.name"
                        :value="[item.authority, item.id]"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                </div>
                <div class="flex">
                  <el-form-item label="账号状态：" prop="state">
                    <el-radio-group v-model="ruleForm.state">
                      <el-radio :label="1">启用</el-radio>
                      <el-radio :label="0">禁用</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="邮箱：" prop="email" label-width="80px">
                    <el-input v-model="ruleForm.email" class="gray" placeholder="请输入邮箱"></el-input>
                  </el-form-item>
                </div>
                <el-form-item label="备注：" prop="remarks">
                  <el-input
                    type="textarea"
                    class="gray"
                    :rows="2"
                    placeholder="请输入内容"
                    v-model="ruleForm.remarks"
                  ></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
          <div class="authority">
            <div class="tit">权限设置</div>
            <div class="dataScope">
              <p class="dataScope-title">数据范围：</p>
              <div class="dataScope-content">
                <div class="select commodity">
                  <p class="select-tit">商品</p>
                  <div class="select-content">
                    <span class="bable">商品分类：</span>
                    <el-select
                      class="gray"
                      v-model="formData.classify"
                      filterable
                      collapse-tags
                      multiple
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in classifyDate"
                        :key="item.id"
                        :label="item.cateName"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="select-content">
                    <span class="bable">商品品牌：</span>
                    <el-select
                      class="gray"
                      v-model="formData.brand"
                      filterable
                      collapse-tags
                      multiple
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in brandDate"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
                <div class="select customer">
                  <p class="select-tit">客户</p>
                  <div class="select-content">
                    <span class="bable">客户标签：</span>
                    <el-select
                      class="gray"
                      v-model="formData.customer"
                      filterable
                      collapse-tags
                      multiple
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in customerDate"
                        :key="item.id"
                        :label="item.value"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>
            <div class="authority-lists">
              <div class="list" v-for="(value,index) in lists" :key="index">
                <div class="list-title">
                  <!-- <el-checkbox
                    :indeterminate="value.isIndeterminate"
                    v-model="value.checkAll"
                    disabled
                  >{{value.title}}</el-checkbox>-->
                  {{value.title}}
                </div>
                <div class="list-child">
                  <!-- <el-checkbox-group
                    v-model="value.authority"
                    @change="handleCheckedCitiesChange(index,value.authority)"
                  >
                    <el-checkbox
                      v-for="(child,index) in value.children"
                      :label="child.id"
                      :key="index"
                      :disabled="selectionDepartment.indexOf(child.id)===-1?true:false"
                    >{{child.name}}</el-checkbox>
                  </el-checkbox-group> -->

                  
                  <el-checkbox-group
                    v-model="value.authority"
                    @change="handleCheckedCitiesChange(index,value.authority)"
                  >
                    <div
                      style="display:inline-block;"
                      v-for="(child, idx) in value.children"
                      :key="idx"
                    >
                      <el-checkbox
                        :class="child.keyword == 'ROLE_TOP_WRITE'?'active':''"
                        :label="child.id"
                        :disabled="selectionDepartment.indexOf(child.id)===-1?true:false"
                      >
                        {{child.name}}
                      </el-checkbox>
                      <el-dropdown 
                        v-if="child.keyword == 'ROLE_TOP_WRITE' && (selectionDepartment.indexOf(child.id) !==-1?true:false)" 
                        trigger="click" 
                        @command="handleCommand">
                        <span class="el-dropdown-link">
                          {{COLUMN_TYPE[columnType]}}<i class="el-icon-caret-bottom"></i>
                        </span>
                        <el-dropdown-menu slot="dropdown" class="client-dropdown">
                          <el-dropdown-item 
                          :disabled="selectionDepartment.indexOf(firstColumnId)===-1?true:false"
                          :command="beforeHandleCommand('one', firstColumnId, index)">首个栏目</el-dropdown-item>
                          <el-dropdown-item
                          :disabled="selectionDepartment.indexOf(allColumnId)===-1?true:false"
                          :command="beforeHandleCommand('all', allColumnId, index)"
                          >所有栏目</el-dropdown-item>
                        </el-dropdown-menu>
                      </el-dropdown>
                    </div>
                  </el-checkbox-group>
                </div>
              </div>
            </div>
          </div>
          <div class="operations" ref="operations">
            <el-button class="btn-white" @click="cancel">取消</el-button>
            <el-button class="btn-blue" @click="save('ruleForm')">保存</el-button>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script >
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import DBSiteSet from 'models/db/site-set.js';
import DBCommodity from 'models/db/commodity.js';
import DBClient from 'models/db/client.js';
const dbClient = new DBClient();
const dbCommodity = new DBCommodity();
const dbSiteSet = new DBSiteSet();
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入密码'));
      } else {
        if (this.ruleForm.checkPass !== '') {
          this.$refs.ruleForm.validateField('checkPass');
        }
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== this.ruleForm.pass) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    return {
      ruleForm: {
        username: '',
        pass: '',
        checkPass: '',
        name: '',
        state: 1,
        phone: '',
        department: '',
        position: '',
        email: '',
        remarks: ''
      },
      rules: {
        username: [
          { required: true, message: '请输入账号名称', trigger: 'blur' }
        ],
        pass: [{ required: true, validator: validatePass, trigger: 'blur' }],
        checkPass: [
          { required: true, validator: validatePass2, trigger: 'blur' }
        ],
        name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { min: 11, max: 11, message: '手机格式错误', trigger: 'blur' }
        ],
        position: [{ required: true, message: '请输入职位', trigger: 'blur' }],
        department: [
          { required: true, message: '请选择部门', trigger: 'change' }
        ],
        state: [
          { required: true, message: '请选择是否启用', trigger: 'change' }
        ]
      },
      formData: {
        classify: [],
        brand: [],
        customer: []
      },
      classifyDate: [],
      brandDate: [],
      customerDate: [],
      department: [], // 所有部门数据
      selectionDepartment: [], // 选中的部门
      lists: [
        // {
        //   title: '商品',
        //   checkAll: false,
        //   authority: ['查看商品', '商品管理'],
        //   children: [
        //     '查看商品',
        //     '商品管理',
        //     '商品导出',
        //     '新增商品',
        //     '商品分类',
        //     '运费管理'
        //   ],
        //   isIndeterminate: false
        // }
      ],
      // 选择的栏目
      columnType: '',
      // 首个栏目id
      firstColumnId: '',
      // 所有栏目id
      allColumnId: '',
      COLUMN_TYPE: {
        // firstColumnId: '首个栏目',
        // allColumnId: '所有栏目',
      },
    };
  },
  components: {
    SecondMenuLinkContent
  },
  watch: {
    'ruleForm.department': {
      handler(newVal, oldVal) {
        let arr = newVal[0];
        // 找到这个所有的权限
        this.lists.map((value, index, array) => {
          arr.map((v, i, a) => {
            if (value.id === v.id) {
              this.$set(this.lists[index], 'authority', v.authorityIds);
              if (v.id == 4) {
                let columnList = [this.allColumnId, this.firstColumnId]
                v.authorityIds.map(j => {
                  if (columnList.indexOf(j) !== -1) {
                    this.columnType = j
                  }
                })
              }
            }
          });
        });
        // 将这个部门没有的权限为不可选状态
        this.selectionDepartment = [];
        arr.map((value, index, array) => {
          value.authorityIds.map((v, i, a) => {
            this.selectionDepartment.push(v);
          });
        });
      },
      deep: true
    }
  },
  mounted() {
    const paddingWidth = 48;
    this.$refs.operations.style.width =
      this.$refs.steps.clientWidth + paddingWidth - 16 + 'px';
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.steps.clientWidth + paddingWidth - 16 + 'px';
    };
  },
  created() {
    this.getList();
    this.getDepartment();
    this.getClassify();
    this.getBrand();
    this.getCustomer();
  },
  methods: {
    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(command, value, index){
      return {
        'value': value,
        'index': index,
        'command':command
      }
    },
    handleCommand(command) {
      let authority = this.lists[command.index].authority
      switch (command.command) {
        case "one":
          let arr = []
          authority.map(i => {
            if (i != this.allColumnId) {
              arr.push(i)
            }
          })
          this.lists[command.index].authority = arr
          this.columnType = command.value
          break;
        case "all":
          let arrCopy = []
          authority.map(i => {
            if (i != this.firstColumnId) {
              arrCopy.push(i)
            }
          })
          this.lists[command.index].authority = arrCopy
          this.columnType = command.value
          break;
      }
    },
    // 返回上一页面
    goEmployeeManage() {
      this.$router.push('employee-manage');
    },
    // 获取部门数据
    getDepartment() {
      dbSiteSet.getDBAllDepartment().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index, array) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            obj.authority = value.authorityIds;
            arr.push(obj);
          });
          this.department = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取权限列表数据
    getList() {
      dbSiteSet.getDBAuthority().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map((value, index, array) => {
            let obj = {};
            obj.title = value.name;
            obj.id = value.id;
            obj.checkAll = false;
            obj.isIndeterminate = false;
            obj.authority = [];
            obj.children = [];
            value.authorities.map((value, index, array) => {
              let child = {};
              child.name = value.name;
              child.id = value.id;
              child.keyword = value.keyword;
              if (value.keyword === 'ROLE_TOP_WRITE_FIRST') {
                this.firstColumnId = value.id
                this.COLUMN_TYPE[this.firstColumnId] = '首个栏目'
              }
              if (value.keyword === 'ROLE_TOP_WRITE_ALL') {
                this.allColumnId = value.id
                this.COLUMN_TYPE[this.allColumnId] = '所有栏目'
              }
              if (value.keyword !== 'ROLE_TOP_WRITE_FIRST' && value.keyword !== 'ROLE_TOP_WRITE_ALL') obj.children.push(child);
            });
            arr.push(obj);
          });
          this.lists = arr;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取商品分类
    getClassify() {
      dbCommodity.getDBGoodsClassify().then(res => {
        if (res.success) {
          this.classifyDate = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取商品品牌
    getBrand() {
      dbCommodity.getCommodityAllBrand().then(res => {
        if (res.success) {
          this.brandDate = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取客户标签
    getCustomer() {
      dbClient.getClientTagList().then(res => {
        if (res.success) {
          this.customerDate = res.result;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleCheckedCitiesChange(index, value) {
      // console.log(this.selectionDepartment);
      let checkedCount = value.length;
      this.lists[index].checkAll =
        checkedCount === this.lists[index].children.length;
      this.lists[index].isIndeterminate =
        checkedCount > 0 && checkedCount < this.lists[index].children.length;
    },
    // 保存修改
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          // 上传数据
          // let authorityIds = JSON.stringify(temp);
          let data = {};
          data.username = this.ruleForm.username;
          data.password = this.ruleForm.pass;
          data.status = this.ruleForm.state;
          data.telephone = this.ruleForm.phone;
          let surePassword = this.ruleForm.pass;
          let departmentId = this.ruleForm.department[1];
          let contact = this.ruleForm.name;
          let position = this.ruleForm.position;
          let email = this.ruleForm.email;
          let note = this.ruleForm.remarks;
          let arr = [];
          this.lists.map((value, index, Array) => {
            let obj = {};
            obj.id = value.id;
            obj.authorityIds = value.authority;
            arr.push(obj);
          });
          let authorityIds = arr;
          let limitCategory = this.formData.classify;
          let limitBrand = this.formData.brand;
          let limitLabel = this.formData.customer;
          dbSiteSet
            .postDBEmployee(
              data,
              surePassword,
              departmentId,
              contact,
              email,
              position,
              note,
              authorityIds,
              limitCategory,
              limitBrand,
              limitLabel
            )
            .then(res => {
              if (res.success) {
                this.$message.success('添加成功！');
                this.$router.push({
                  name: 'employee-manage',
                  params: {
                    change: true
                  }
                });
              } else {
                this.$message.error(res.message);
              }
            });
        } else {
          this.$message.error('请输完整');
          return false;
        }
      });
    },
    // 取消
    cancel() {
      this.$router.push('employee-manage');
    }
  }
};
</script>

<style lang="scss" scoped>
.employee-add-account {
  width: 100%;
  height: 100%;
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .employee-add-account-main {
    .tit {
      height: 32px;
      background: rgba(245, 247, 250, 1);
      border-radius: 8px 8px 0px 0px;
      padding-left: 6px;
      line-height: 32px;
      color: rgba(48, 49, 50, 1);
      font-size: 16px;
    }
    .form-container {
      .form {
        padding-top: 16px;
      }
    }
    .authority {
      .dataScope {
        padding: 16px 0 0 20px;
        font-size: 14px;
        display: flex;
        .dataScope-title {
          line-height: 32px;
        }
        .dataScope-content {
          display: flex;
          flex-direction: column;
          .select {
            display: flex;
            margin-bottom: 16px;
            align-items: flex-start;
            .select-tit {
              line-height: 32px;
              width: 70px;
              padding-left: 10px;
            }
            .select-content {
              display: flex;
              margin-right: 60px;
              .bable {
                line-height: 32px;
                width: 80px;
              }
            }
          }
        }
      }
      .authority-lists {
        padding: 0 0 36px 0;
        .list {
          margin-bottom: 16px;
          font-size: 14px;
          letter-spacing: 1px;
          .list-title {
            height: 40px;
            box-sizing: border-box;
            background: rgba(234, 238, 245, 0.2);
            border-radius: 8px 8px 0px 0px;
            border: 1px solid rgba(234, 238, 245, 1);
            padding: 0px 30px 0 16px;
            display: flex;
            align-items: center;
          }
          .list-child {
            box-sizing: border-box;
            border: 1px solid #f2f6fc;
            border-top: 0;
            padding: 0px 30px 0 36px;
            display: flex;
            align-items: center;
            .el-checkbox {
              line-height: 40px;
              margin-right: 64px;
            }
            .active {
              margin-right: 10px;
            }
            .el-dropdown-link {
              margin-right: 64px;
              cursor: pointer;
            }
          }
        }
      }
    }
    .operations {
      z-index: 10000;
      height: 60px;
      position: fixed;
      left: 256px;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
      .el-button {
        width: 96px;
        letter-spacing: 4px;
      }
      .el-button + .el-button {
        margin-left: 24px;
      }
    }
  }
}
</style>
<style lang="scss">
.employee-add-account {
  .employee-add-account-main {
    .form-container {
      .form {
        .el-form {
          .el-form-item__label {
            padding: 0;
          }
          .el-radio {
            margin-right: 16px;
          }
          .is-success {
            .el-input__inner:focus {
              border-color: #3d74f2;
            }
          }
          .is-error {
            .el-input__inner:focus {
              border-color: #3d74f2;
            }
          }
          .flex {
            display: flex;

            .el-form-item__content {
              width: 160px;
            }
          }
          .el-form-item__content {
            width: 400px;
            .el-textarea__inner {
              background: rgba(234, 238, 245, 0.2);
              border-radius: 4px;
              border: 1px solid rgba(234, 238, 245, 1);
            }
            .el-textarea__inner:hover {
              border-color: rgba(192, 196, 204, 1);
            }
            .el-textarea__inner:focus {
              border-color: rgba(61, 116, 242, 1);
            }
          }
        }
      }
    }
    .authority {
      .el-select {
        min-width: 250px;
        .el-tag {
          max-width: 150px;
          display: flex;
          align-items: center;
          .el-select__tags-text {
            max-width: 100px;
            display: inline-block;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .el-icon-close {
            top: 1px;
          }
        }
      }
    }
  }
}
</style>
